/**
 * Vue.js 2.0 plugin for Sentry (sentry.io)
 */

import * as Sentry from '@sentry/browser';
import formatComponentName from '~vue/helpers/format-component-name';

const plugin = {
  install(Vue) {
    const oldOnError = Vue.config.errorHandler;
    const vueConfig = Vue.config;
    vueConfig.errorHandler = function handleError(error, vm, info) {
      Sentry.captureException(error, {
        logger: 'VueErrorHandler',
        extra: {
          vueComponentName: formatComponentName(vm),
          vueComponentProps: vm.$props,
          vueComponentData: vm.$data,
          vueErrorInfo: info,
        },
      });

      if (typeof oldOnError === 'function') {
        oldOnError.call(this, error, vm, info);
      }
    };
  },
};

export default plugin;
